module.exports = __webpack_public_path__ + "img/Bitmap@2x41.52d130a5.png";